import axiosInstance from "../api.axiosInstance"
import type { CreateUserLicenseDto, LicenseDto } from "../dto/user-license.dto"

export class UserLicenseService {
  async createLicense(
    userId: string,
    dto: CreateUserLicenseDto,
  ): Promise<LicenseDto> {
    try {
      const response = await axiosInstance.post(
        `user/v1/${userId}/licenses`,
        dto,
      )
      return response.data
    } catch (error: any) {
      const errorData = error.response?.data
      const errorMessage = errorData?.message || error.message

      if (error.response?.status === 400) {
        throw new Error(`Invalid license data: ${errorMessage}`)
      }
      if (error.response?.status === 404) {
        throw new Error(`User not found`)
      }
      if (error.response?.status === 500) {
        throw new Error(`Failed to create license: ${errorMessage}`)
      }
      throw error
    }
  }
}

export const userLicenseService = new UserLicenseService()
